import React, {ReactNode} from "react"
import styled from "styled-components"

import {H4, Body} from "@irati/ui/src/Typography"
import id from "@irati/utils/id"
import Flex from "@irati/ui/src/Flex"
import Spacing from "@irati/ui/src/Spacing"

const Wrapper = styled.div`
  width: 65%;
  > * {
    &:not(:last-child) {
      margin-right: 15px;
    }
  }
`

interface Props {
  title: string,
  value: string,
  children: ReactNode
}

const SettingsLink = (props: Props) => {
  const {title, value, children} = props
  const idNamespace = id("company-settings-title", props)
  return (
    <Flex direction="column" marginBottom={4} id={idNamespace}>
      <Spacing marginBottom={2}>
        <H4 marginBottom={1} id={id("title", idNamespace)}>{title}</H4>
        <Body id={id("copy", idNamespace)}>{value}</Body>
      </Spacing>
      <Wrapper>
        {children}
      </Wrapper>
    </Flex>
  )
}

export default SettingsLink
